<template>
  <div class="agreement-wrap">
    <el-card shadow="hover" class="agreement-card">
      <div class="header">
        <h2>喜铺破包子会员卡及会员服务活动条款与条件须知</h2>
      </div>
      <div class="scroll-box">
        <div class="article" v-html="agreementText"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "MemberAgreementShow",
  data() {
    return {
      agreementText: `
<div class="section">
  <p>活动条款与条件须知</p>
  <p>尊敬的喜铺破包子包友，您好：</p>
  <p>欢迎成为喜铺破包子会员，您可以在喜铺破包子门店、小程序以及其他喜铺破包子公司指定的渠道注册成为喜铺破包子会员，您可以通过所注册的喜铺破包子会员账户，在喜铺破包子公司指定的门店享受会员权益，您亦可根据喜铺破包子公司提供的其他会员开通途径注册会员。您必须仔细阅读并遵守《喜铺破包子会员卡及会员服务活动条款与条件须知》</p>
  <p>请您务必审慎阅读、充分理解本协议、预付卡章程及隐私权政策各条款内容，特别是免除或限制责任的相应条款，并选择接受或不接受。免除或限制责任条款可能以加粗形式提示您注意。除非您已阅读并接受本协议及预付卡章程所有条款，否则您将无法使用喜铺破包子会员服务。您成功注册成为喜铺破包子会员，即视为您已阅读并同意受本协议、预付卡章程、隐私权政策的约束。</p>
  <p>喜铺破包子会员卡是喜铺破包子虚拟会员卡，属于喜铺破包子会员卡的一种，喜铺破包子公司可能会不时推出新种类会员卡、其他可注册喜铺破包子会员账户的产品或活动，通过该等会员卡或产品、活动注册喜铺破包子会员账户受本协议、预付卡章程、隐私权政策相关特别规定的约束，若本协议、预付卡章程或隐私权政策与该特别规定有任何不一致的，以该特别规定的内容为准，特别规定未尽事宜，以本协议、预付卡章程及隐私权政策约定为准。</p>
  <p>您注册喜铺破包子会员账户时需按照喜铺破包子公司的要求提供真实完整的个人信息，包括真实姓名、电话号码及生日日期等。同时，您同意维护并及时更新个人的喜铺破包子会员账户信息，我们将根据法律法规及隐私权政策妥善的保管会员个人信息，您因信息不准确及更新不及时而导致的任何损失均由您自行承担。您同意喜铺破包子公司根据法律法规及监管政策妥善保管及使用您的前述个人信息。如果您未满18周岁，请在法定监护人的陪同下阅读本协议并征得您的法定监护人的同意。</p>
  <p>您所注册的喜铺破包子会员卡为不记名卡，不挂失，不补办。喜铺破包子会员卡与喜铺破包子会员账户使用时不找零、不可兑换现金</p>
  <p>为了保护您个人的权益，请您妥善保管您所属的喜铺破包子会员账户的个人账号和密码，不应告知他人，也不应该将您的喜铺破包子会员卡与喜铺破包子会员账户出售、转赠或借给其他人，您应对自己的喜铺破包子会员账户内所发生的行为负全部责任，请妥善地保管您的喜铺破包子会员账户账号密码和喜铺破包子会员卡。</p>
  <p>除本协议所述的会员权益外，喜铺破包子公司不定时推出的其它会员权益或活动，也受本协议、预付卡章程、隐私权政策及喜铺破包子公司届时制定的相关特别规定的约束，若本协议、预付卡章程或隐私权政策与该特别规定有任何不一致的，以该特别规定的内容为准，特别规定未尽事宜，以本协议、预付卡章程及隐私权政策约定为准。</p>
</div>

<div class="section">
  <h3>【注册方式】</h3>
  <p>您只需在喜铺破包子门店点单小程序注册一个喜铺破包子会员账户，即可享受喜铺破包子会员账户中所述的会员权益。</p>
</div>

<div class="section">
  <h3>【喜铺破包子会员账户的使用】</h3>
  <p>1.您注册成为喜铺破包子会员后将会获得会员码权益。该喜铺破包子会员账户是您的专属账户，不可转赠；您通过喜铺破包子公司提供的其他产品、活动注册的喜铺破包子会员账户，该会员账户亦不可转赠</p>
  <p>2.任何人使用了您的喜铺破包子会员账户因购买产生的积分，都将记录到您的账户中，同样的，任何人通过出示您的喜铺破包子会员账户来使用电子优惠券或行使权益时，将被视为您本人的行为，已被使用的电子优惠券将从您的喜铺破包子会员账户中扣除。</p>
  <p>3.在您成功注册喜铺破包子会员账户之后，您每次到喜铺破包子门店购买时，因购买产生的积分将记录在您所属的喜铺破包子会员账户中。如果您因退货、退款等各种原因导致购买未成功，那么喜铺破包子公司有权撤销您此次购买所产生的积分及成长值，您账户中的累计积分及成长值也会相应改变。</p>
  <p>4.请注意使用喜铺破包子会员优惠券、购买单用途商业预付卡、第三方积分消费、外卖、电话预订的行为，不会获得积分，事后也不会提供补录积分服务。</p>
  <p>5.当您在喜铺破包子门店中进行消费时，根据您喜铺破包子会员账户中的电子优惠券，您将享受相应的会员优惠，当您使用喜铺破包子会员账户中的电子优惠券时，相应的电子优惠券会从您的喜铺破包子会员账户中扣除。您账户中的电子优惠券会显示使用时间和截止时间，还请您在规定的时间内正确使用完您账户中的电子优惠券，电子优惠券逾期不补。</p>
</div>

<div class="section">
  <h3>【新会员权益】</h3>
  <p>1.可以参加喜铺破包子持续推出的各种会员活动。</p>
  <p>2.线下现金消费1元可获得1积分，积分可在积分商城中兑换电子优惠券、周边商品等。</p>
  <p>3.新会员注册可领取新会员注册礼包，具体优惠以领取实际优惠为准。</p>
  <p>*所有的会员权益仅限喜铺破包子品牌指定门店、喜铺破包子点单小程序及喜铺破包子指定渠道可使用；</p>
</div>

<div class="section">
  <h3>【喜铺破包子会员账户适用范围】</h3>
  <p>喜铺破包子会员小程序及喜铺破包子指定渠道可使用。</p>
</div>

<div class="section">
  <h3>【定义】</h3>
  <p>•积分：积分是喜铺破包子会员的虚拟币，积分可在积分商城兑换礼品，所有积分不具有任何现金价值。</p>
  <p>•积分周期：自您喜铺破包子会员账户获得积分之日起(T+1年)为一个积分周期，积分的有效期以积分周期为计算单位，到期积分自动清零，有效期内未进行使用或兑换的积分，将于有效期最后一天自动清零。</p>
  <p>•累计积分：会员在有效期内获取的积分总计，喜铺破包子会员账户到达有效期，累计积分将自动清零。</p>
  <p>•可用积分：展示在首页的可用于在积分商城中兑换的喜铺破包子虚拟币，您每次可用的积分会随着您兑换的积分数相应减少</p>
  <p>•积分商城：为喜铺破包子虚拟币兑换商城，会员可在积分商城中凭积分兑换礼品；</p>
  <p>•生日：是指您在注册会员时填写的生日日期，若与您的实际生日日期不一致，我们将以您在喜铺破包子会员账户中填写的生日日期为准</p>
</div>

<div class="section">
  <h3>【条款更改】</h3>
  <p>基于会员功能、使用规则的变化、法律法规及监管要求，喜铺破包子公司将适时对本协议及预付卡章程进行修订，如若我们要更改本协议或预付卡章程的条款和条件，喜铺破包子公司将会提前合理的时间在喜铺破包子会员系统中通知相关的更改(法律、法规明确规定不能提前通知的情形除外)，更改后的条款和条件将于通知中载明的日期生效。</p>
  <p>若您在收到更改通知之后，使用了您的喜铺破包子会员卡或喜铺破包子会员账户，那么您在该更改日期当日或之后对喜铺破包子会员卡或喜铺破包子会员账户的首次使用将被视为您同意且接受该更改。</p>
  <p>若您不同意通知中的更改，那么您应当在您的电子优惠券过期前或者在通知中的更改生效前(按两者时间中较早的为准)使用电子优惠券，随后您应停止继续使用您的喜铺破包子会员卡及喜铺破包子会员账户</p>
</div>

<div class="section">
  <h3>【违约责任】</h3>
  <p>请勿违规刷积分(包括但不限于虚拟交易、恶意退款)，如果喜铺破包子公司发现或收到他人举报您有违反本协议任何行为的，喜铺破包子公司有权依法进行独立判断并采取技术手段对您的会员卡账户进行临时查封立即清除账户中部分或所有的累计积分</p>
  <p>喜铺破包子公司有权视您的行为性质，对您采取包括但不限于终止部分或全部喜铺破包子会员服务、终止您对喜铺破包子会员账户的使用、追究您的法律责任等措施，由此给您带来的损失(包括但不限于会员账户封停、相关数据清空、未使用的电子优惠券等用作违约金而归喜铺破包子所有等)，由您自行承担；喜铺破包子公司亦无需向您退还任何费用，若您的行为造成喜铺破包子公司损失的，您还应予以赔偿。</p>
</div>

<div class="section">
  <h3>【适用法律及争议解决】</h3>
  <p>本协议签订地为中华人民共和国广东省深圳市福田区。本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)。凡因喜铺破包子会员卡、喜铺破包子会员账户、喜铺破包子优惠券或本协议引起的任何纠纷、争议或索赔，首先应与深圳市品道餐饮管理有限公司友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
</div>

<div class="section">
  <h3>【其他补充约定】</h3>
  <p>本协议无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
  <p>喜铺破包子公司将通过喜铺破包子会员系统通知、微信公众号通知、短信通知、邮箱通知等多种方式对会员进行通知和公告。您同意接收喜铺破包子公司及喜铺破包子门店向您发送的包括本协议变更、权益变动、优惠活动等通知在内的各项商业性信息。</p>
  <p>在法律法规允许的范围内，喜铺破包子公司及喜铺破包子门店对以下情形导致的喜铺破包子会员服务中断或受阻不承担责任：</p>
  <p>1.受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
  <p>2.电力部门技术调整或故障；</p>
  <p>3.您或喜铺破包子公司的手机或电脑软件、系统、硬件和通信线路出现故障、设备检修或维护；</p>
  <p>4.您个人操作不当；</p>
  <p>5.您违反预付卡章程或本协议约定使用喜铺破包子会员卡或喜铺破包子会员账户；</p>
  <p>6.银行系统或银行网络出现故障；</p>
  <p>7.出现自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等不可抗力；</p>
  <p>8.其他喜铺破包子公司及喜铺破包子门店无法控制或合理预见的情形。</p>
  <p>出现上述情形时，喜铺破包子公司及喜铺破包子门店会尽力减少因此给您造成的损失和影响。因不可抗力或供电、通讯等客观原因导致喜铺破包子会员卡或喜铺破包子生活账户暂时无法使用的，喜铺破包子公司及喜铺破包子门店将视情况协助您解决或为您提供必要的帮助，但不承担相关责任。对于交易过程中，因暂时的网络通讯故障或其他原因造成的错账现象，喜铺破包子公司及喜铺破包子门店将根据实际交易情况进行账务处理，以保障您的权益不受损失</p>
  <p>如果您对本协议、章程或喜铺破包子会员服务有任何意见或建议，可与喜铺破包子客户服务部门联系，我们会给予您必要的帮助。</p>
  </br>
  <p>本须知最终解释权归喜铺破包子品牌运营方所有，所有权益规则以平台实时公示内容为准。</p>
</div>
      `
    };
  }
};
</script>

<style scoped>
.agreement-wrap {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 40px 20px;
  box-sizing: border-box;
}
.agreement-card {
  max-width: 960px;
  margin: 0 auto;
}
.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}
.header h2 {
  font-size: 20px;
  color: #303133;
  margin: 0;
}
.valid-date {
  margin: 8px 0 0;
  font-size: 14px;
  color: #909399;
}
.scroll-box {
  height: 650px;
  overflow-y: auto;
  padding-right: 10px;
}
.article {
  font-size: 15px;
  line-height: 1.8;
  color: #444;
}
.section {
  margin-bottom: 32px;
}
.section h3 {
  font-size: 17px;
  font-weight: 600;
  color: #222;
  margin: 0 0 12px;
}
.section p {
  margin: 0 0 10px;
  text-indent: 2em;
}
/* 美化滚动条 */
.scroll-box::-webkit-scrollbar {
  width: 6px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}
.scroll-box::-webkit-scrollbar-track {
  background: transparent;
}
</style>